import React from "react";

function RideMapLegend() {
  return (
    <ul className="ride-map-legend">
      <li>
        <span className="ride-map-legend__pin ride-map-legend__pin--pickup">A</span>
        Pickup
      </li>
      <li>
        <span className="ride-map-legend__pin ride-map-legend__pin--dropoff">B</span>
        Dropoff
      </li>
    </ul>
  );
}

export default RideMapLegend;
